<template>
    <div class="customer-nutzergruppen-pro-store" v-if="items.length > 0">
        <v-data-table
                hide-default-footer
                disable-pagination
                :headers="headers"
                :items="items"
        >
            <template slot="item" slot-scope="props">
                <tr :class="props.item.class">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.description }}</td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>

export default {
    name: 'NutzergruppenProStore',
    props: [
        'usergroups',
    ],
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false,
                    align: 'left',
                    width: 250,
                },
                {
                    text: 'Name',
                    value: 'name',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Beschreibung',
                    value: 'description',
                    sortable: false,
                    align: 'left',
                },
            ],
        };
    },
    computed: {
        items() {
            const u = this.usergroups || {};
            /* eslint-disable-next-line */
            return Object.keys(u).map(key => ({
                id: key,
                name: u[key].name,
                description: u[key].description,
                class: '',
            }));
        },
    },
};

</script>
<style scoped lang="scss"></style>
